
define('app/board/collections/rosterPositionCollection',[
	'jquery',
	'underscore',
	'backbone',
	'app/board/models/rosterPositionModel',
	'app/board/collections/pickSummaryCollection',
	'known/models/leagueInstanceModel',
	'app/board/models/draftStatusModel',
], function($, _, Backbone, RosterPositionModel, PickSummaryCollection, LeagueInstanceModel, DraftStatusModel){
	var RosterPositionCollection = Backbone.Collection.extend({
		model : RosterPositionModel,
		
		initialize: function(models, options) {
			this.leagueInst = options.leagueInst;
			this.processChanges = true;
			this.draftStatusModel = options.draftStatusModel;
			this.pickSummaries = options.pickSummaries;
			this.benchData = {};
			this.teamRoster = {}; //fantTeamId : [rosterPosId]
			
			_.bindAll(this, 'populateAllRosters');
			_.bindAll(this, 'updateTeamRoster');
			_.bindAll(this, 'populateRoster');
			
			this.pickSummaries.on('reset', this.populateAllRosters, this);
			this.pickSummaries.on('change', this.updateTeamRoster, this);
	    },
	    
	    populateAllRosters: function() {
	    	if(!this.processChanges){
				return this;
			}
	    	
			this.leagueInst.get('fantasyTeams').each(function(team) {
				this.populateRoster(team);
			}, this);
		},
		
		setProcessChanges: function(isProcessChanges){
			this.processChanges = isProcessChanges;
		},
		
		updateTeamRoster: function(pickSummary) {
			if(!this.processChanges){
				return this;
			}
			
			if(pickSummary){
				var team = this.leagueInst.get('fantasyTeams').get(pickSummary.get('fantasyTeamId'));
				if(team) {
					this.populateRoster(team);
				}
			}
			 
		},
		
		populateRoster:function(fantTeam) {
			var posMap = this.draftStatusModel.get('teamPosMap')[fantTeam.get('id')]; // {lgPosId : [pickValue]}
			var maxNumPicks = this.draftStatusModel.get('teamMaxNumPicks')[fantTeam.get('id')]; 
			var processedPicks = {};
			var pickSummaries = this.pickSummaries;
			var sortFunc = this.sortNumber;
			
			this.leagueInst.get('leaguePositions').each(function(lgPos) {
				var pickArr = posMap[lgPos.get('id')];
				if(pickArr && pickArr.length > 0){
					pickArr = pickArr.sort(sortFunc);
				} else {
					pickArr = [];
				}
				
				var startersFound = 0;
				var i = 1;
				while(startersFound < lgPos.get('starters') && i <= pickArr.length){
					var rosterPositionModel = this.get(fantTeam.get('draftPosition') + ':' + lgPos.get('id').replace(',','.') + ':' + (startersFound+1));
					if(!processedPicks[pickArr[i-1]]){
						var pickSummary = null;
						
						if(this.leagueInst.get('draftType') == 'AUCTION') {
							pickSummary = pickSummaries.getAucPickByPosRoundId(pickArr[i-1]);
						} else {
							pickSummary = pickSummaries.get(pickArr[i-1]);
						}
						
						if(rosterPositionModel.get('pickId') != pickSummary.get('pickId')){
							rosterPositionModel.set({
								pickId: pickSummary.get('pickId'),
								keeper: pickSummary.get('keeper'), 
								playerPos: pickSummary.get('playerPos'), 
								byeWeek: pickSummary.get('byeWeek'), 
								teamAbbr: pickSummary.get('teamAbbr'), 
								fName: pickSummary.get('fName'), 
								lName: pickSummary.get('lName'), 
								auctionValue: pickSummary.get('auctionValue'),
								draftablePlayerId : pickSummary.get('draftablePlayerId'),
							});
						}						
						
						processedPicks[pickArr[i-1]] = true;
						startersFound++;
					}
					
					i++;
				}
				
				for(var i=(startersFound+1); i<=lgPos.get('starters'); i++){
					var rosterPositionModel = this.get(fantTeam.get('draftPosition') + ':' + lgPos.get('id').replace(',','.') + ':' + i);
					if(rosterPositionModel.get('pickId') != null){
						rosterPositionModel.clearPlayerInfo();
					}					
				}
			}, this);
			
			//Get all of this team's draft picks
			var allPosArr = posMap['ALL_POSITIONS'];
			if(allPosArr && allPosArr.length > 0){
				allPosArr = allPosArr.sort(this.sortNumber);
			} else {
				allPosArr = [];
			}
			
			//Get the max number of bench picks any team has made
			//var maxAllBenchNum = 0;
			//for(var fantTeamId in this.benchData) {
			//	if(this.benchData[fantTeamId] > maxAllBenchNum && fantTeamId != fantTeam.get('id')){
			//		maxAllBenchNum = this.benchData[fantTeamId]; 
			//	}
			//}
						
			//Add Bench positions
			var numBenchSpots = 0;
			for (var i = 1; i <= maxNumPicks; i++) {
				var rosterPositionModel = this.get(fantTeam.get('draftPosition') + ':BENCH:' + (numBenchSpots+1));
				if(i <= allPosArr.length && !processedPicks[allPosArr[i-1]]){
					var pickSummary = null;
					
					if(this.leagueInst.get('draftType') == 'AUCTION') {
						pickSummary = pickSummaries.getAucPickByPosRoundId(allPosArr[i-1]);
					} else {
						pickSummary = pickSummaries.get(allPosArr[i-1]);
					}
					
					if(rosterPositionModel.get('pickId') != pickSummary.get('pickId')){
						rosterPositionModel.set({
							pickId: pickSummary.get('pickId'),
							keeper: pickSummary.get('keeper'), 
							playerPos: pickSummary.get('playerPos'), 
							byeWeek: pickSummary.get('byeWeek'), 
							teamAbbr: pickSummary.get('teamAbbr'), 
							fName: pickSummary.get('fName'), 
							lName: pickSummary.get('lName'), 
							auctionValue: pickSummary.get('auctionValue'),
							draftablePlayerId : pickSummary.get('draftablePlayerId'),
						});
					}
					
					processedPicks[allPosArr[i-1]] = true;
					numBenchSpots++;
				}
			}
			
			this.benchData[fantTeam.get('id')] = numBenchSpots;
			
			for (var i = 1; i <= maxNumPicks; i++) {
				if(i > numBenchSpots){
					var rosterPositionModel = this.get(fantTeam.get('draftPosition') + ':BENCH:' + i);
					if(rosterPositionModel.get('pickId') != null){
						rosterPositionModel.clearPlayerInfo();
					}
				}
			}						
		},
		
		initCollectionData: function () {
			var numTeams = this.leagueInst.numTeams();
			var maxNumPicksMap = this.draftStatusModel.get('teamMaxNumPicks');
			var maxNumPicks = 0;
			var numStarters = 0;
			
			for(var fantTeamId in maxNumPicksMap) {
				if(maxNumPicksMap[fantTeamId] > maxNumPicks){
					maxNumPicks = maxNumPicksMap[fantTeamId]; 
				}
			}
			
			this.leagueInst.get('fantasyTeams').each(function(team) {
				this.teamRoster[team.get('id')] = [];
			}, this);
			
			//Add a model for each starting position
			this.leagueInst.get('leaguePositions').each(function(lgPos) {
				for(var i=1; i<=lgPos.get('starters'); i++){
					for (var j = 1; j <= numTeams; j++) {
						var curTeam = this.leagueInst.getTeamByDraftPosition(j);
						var posId = lgPos.get('id').replace(',','.');
						var id = j + ':' + posId + ':' + i;
						var newPosition = new RosterPositionModel({
							id: id, //draftPosition:pos:posRank
							pickId: null,
							keeper: false, //
							playerPos: null, //
							byeWeek: null, //
							teamAbbr: null, //
							fName: null, //
							lName: null, //
							auctionValue: null, //
							fantasyTeamId : curTeam.get('id'), //
							draftablePlayerId : null,
							lgPos: lgPos, //
							posRank: i, //
							optional: false,
						});
						this.add(newPosition);
						
						this.teamRoster[curTeam.get('id')].push(id);
					}
					
					numStarters++;
				}
				
			}, this);			
			
			//Add Bench models
			for (var i = 1; i <= maxNumPicks; i++) {
				for (var j = 1; j <= numTeams; j++) {
					var optional = false;
					var curTeam = this.leagueInst.getTeamByDraftPosition(j);
					if(maxNumPicksMap[curTeam.get('id')] < (i + numStarters)){
						optional = true;
					}
					
					var id = j + ':BENCH:' + i;
					var newPosition = new RosterPositionModel({
						id: id, //draftPosition:pos:posRank
						pickId: null,
						keeper: false, //
						playerPos: null, //
						byeWeek: null, //
						teamAbbr: null, //
						fName: null, //
						lName: null, //
						auctionValue: null, //
						fantasyTeamId : curTeam.get('id'), //
						draftablePlayerId : null,
						lgPos: null, //
						posRank: i, //
						optional: optional,
					});
					this.add(newPosition);
					this.teamRoster[curTeam.get('id')].push(id);
				}
			}
			
			this.populateAllRosters();
		},
		
		sortNumber: function (a,b) {
			//We want auction keepers to always be sorted ahead of non-keepers
			//Auction keepers closer to 0 should be sorted ahead of larger ones.
			if(a > 0 && b > 0){
				return a - b;
			} else if(a > 0){
				return 1;
			} else if(b > 0){
				return -1;
			} else {
				return Math.abs(a) - Math.abs(b);
			}   
		}
	});
	
	return RosterPositionCollection;  
});